import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { updateDevicesPageSelectedDeviceId, updateDevicesPageExpandedBundleId } from 'redux/actions';
import { getMainUnitFromBundleMembers } from 'common/utils/helpers';
import { isGa2Device, isItBundle } from 'common/utils/deviceTwinUtils';
import { deviceDisplayTypes, DEVICES_PAGE_TAB } from 'common/utils/constants';
import { Link } from 'react-router-dom';
import { DeviceCheckBox } from '../DeviceCheckBox';

const DeviceTableDeviceIdAndNameCell = ({ row, forAlarmMap, onlyDeviceId }) => {
  let deviceNameValues = {
    ...(row.value?.id && { deviceID: row.value.id }),
    ...(row.value?.tags?.userLabel && { userLabel: row.value.tags.userLabel })
  };
  // Store the current width of the row in localStorage 
  localStorage.setItem('deviceColumnWidth', row.width);

  let bundleDonor = null;
  const devicesPage = useSelector((store) => store.ui.devicesPage);
  const activeTab = devicesPage.activeTab;
  let displayType;
  switch (activeTab) {
    case DEVICES_PAGE_TAB.pivot:
      displayType = devicesPage.pivotTab.deviceDisplayMode;
      break;
    case DEVICES_PAGE_TAB.echo:
      displayType = devicesPage.echoTab.deviceDisplayMode;
      break;
    case DEVICES_PAGE_TAB.all:
      displayType = devicesPage.allDevicesTab.deviceDisplayMode;
      break;
    default:
      displayType = deviceDisplayTypes.ID;
  }
  let defaultDeviceAccessor = deviceNameValues.deviceID ? deviceNameValues.deviceID : '';
  let targetDeviceDisplay = null;
  let isBundle = isItBundle(row.original);
  const isGa2 = isGa2Device(row.original);

  switch (displayType) {
    case deviceDisplayTypes.ID:
      if (isBundle) {
        targetDeviceDisplay = row.original.code ? row.original.code : 'POD-Unknown';
      } else {
        targetDeviceDisplay = defaultDeviceAccessor;
      }
      break;
    case deviceDisplayTypes.NAME:
      if (isBundle) {
        targetDeviceDisplay = row.original.name;
      } else {
        targetDeviceDisplay = deviceNameValues.userLabel ? deviceNameValues.userLabel : defaultDeviceAccessor;
      }
      break;
    default:
      targetDeviceDisplay = defaultDeviceAccessor;
  }

  if (isBundle) {
    if (row.original.name !== 'Unnamed site' && !row.original.code) {
      targetDeviceDisplay = row.original.name;
    }
    bundleDonor = getMainUnitFromBundleMembers(row.original?.members);
  }

  let selectedId = isBundle && row?.value?.bundleId ? row.value.bundleId : row.value && row.value.deviceId;
  const dispatch = useDispatch();
  const expandedBundleId = useSelector((store) => store.ui.devicesPage.expandedBundleId);

  return (
    <div id="DeviceTable_cellWrapper" className="idColumn DeviceTable_cellWrapper">
      {forAlarmMap || onlyDeviceId ? null : (
        <DeviceCheckBox deviceTwin={row.value} targetDeviceID={isBundle ? row.original.bundleId : row.value.id} />
      )}
      {!onlyDeviceId ? (
        <Link
          to={
            '/console/devices/' +
            (isGa2
              ? `pivot/overview?deviceId=${row.value.id}`
              : isBundle
              ? `detail?${bundleDonor.id}`
              : `detail?${row.value.id}`)
          }
          data-tip={onlyDeviceId ? bundleDonor.id : targetDeviceDisplay}
        >
          {onlyDeviceId ? bundleDonor.id : targetDeviceDisplay}
        </Link>
      ) : (
        <div
          id="DeviceTable_cellWrapper"
          className="DeviceTable_cellWrapper"
          data-tip={isBundle ? bundleDonor.id : row.value.id}
        >
          {isBundle ? bundleDonor.id : row.value.id}
        </div>
      )}
      {isBundle && expandedBundleId !== selectedId && !onlyDeviceId && (
        <div
          id="DeviceTable_cellWrapper_ExpandButton"
          className="DeviceTable_cellWrapper_ExpandButton"
          onClick={() => {
            dispatch(updateDevicesPageSelectedDeviceId(selectedId));
            dispatch(updateDevicesPageExpandedBundleId(selectedId));
          }}
        >
          <SvgAF img={IconLoader.icon_expandunits} hover={IconLoader.icon_expandunits_hover} />
        </div>
      )}
      {isBundle && expandedBundleId === selectedId && !onlyDeviceId && (
        <div
          id="DeviceTable_cellWrapper_ExpandButton"
          className="DeviceTable_cellWrapper_ExpandButton"
          onClick={() => {
            dispatch(updateDevicesPageExpandedBundleId(''));
          }}
        >
          <SvgAF img={IconLoader.icon_collapseunits} hover={IconLoader.icon_collapseunits_hover} />
        </div>
      )}
    </div>
  );
};

export default DeviceTableDeviceIdAndNameCell;
